import React from 'react';
import { cond, prop, propEq, sortBy, find } from 'ramda';
import { useIntl } from 'gatsby-plugin-intl';
import { Container, 
  Title, 
  CardWrapper, 
  Card, 
  CardContent,
  NumberContainer,
  HeaderContainer,
  Number,
  Character,
  MarkdownContent
} from './updatedCardGrid.styles';
import {CustomTooltip} from '../customTooltip'

const renderTitle = ({ value }, key) => {
  if(!value) return null
  const intl = useIntl();
  return <Title key={key}>{intl.formatMessage({ id: value })}</Title>;
};

// const renderCardContent = ({ type, value }, key) => {
//   console.log({value})
//   const intl = useIntl();
//   return (
//     <MarkdownContent type={type} key={key}>
//       {intl.formatMessage({ id: value })}
//     </MarkdownContent>
//   );
// };

const renderTooltip = (connection, citation) => {
  if(!connection.value && !citation.value) return null
  return (
    <CustomTooltip connection={connection} citation={citation} />
  )
}

const renderNumber = (number) => {
  const intl = useIntl();
  if (!number) return null
 return <Number>{intl.formatMessage({ id: number })}</Number>
}

const renderCharacter = (character) => {
  const intl = useIntl();
  if(!character) return null
  return <Character>{intl.formatMessage({ id: character})}</Character>
}

const renderCard = ({ elements }, key) => {
  const intl = useIntl()
  if(!elements) return null
  const {value: plainText} = find(propEq('name', 'plain_text'))(elements) || {};
  const {value: markdown} = find(propEq('name', 'markdown'))(elements) || {};
  const connection = find(propEq('name', 'connection'))(elements) || {};
  const citation = find(propEq('name', 'citation'))(elements) || {};
  const number = plainText.slice(0, plainText.length - 1)
  const character = plainText.charAt(plainText.length - 1)
  if(plainText.length > 1 && isNaN(plainText.slice(-1))){
    return (
      <Card key={key}>
        <HeaderContainer>
          {renderTooltip(connection, citation)}
        </HeaderContainer>
        <NumberContainer>
          {renderNumber(number)}
          {renderCharacter(character)}
        </NumberContainer>
          <MarkdownContent>
            {intl.formatMessage({ id: markdown })}
          </MarkdownContent>
      </Card>
    )
  } else return (
    <Card key={key}>
      <HeaderContainer>
        {renderTooltip(connection, citation)}
      </HeaderContainer>
      <MarkdownContent>
        {intl.formatMessage({ id: markdown })}
      </MarkdownContent>
      <NumberContainer>
        {renderNumber(plainText)}
      </NumberContainer>
    </Card>
  )
}

const renderCards = ({ value = [] }, key) => (
  <CardWrapper key={key}>{sortBy(prop('order'))(value).map(renderCard)}</CardWrapper>
);

const renderElement = cond([
  [propEq('name', 'Title'), renderTitle],
  [propEq('name', 'Card'), renderCards],
]);

export const UpdatedCardGrid = ({ elements }) => {
  const orderedElements = sortBy(prop('order'))(elements);

  return <Container short={true}>{orderedElements.map(renderElement)}</Container>;
};
